/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var GovKoRarIcon20Solid = forwardRef('GovKoRarIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M5.432.004a.285.285 0 0 0-.273.267c-.163 2.525 2.04 4.732 4.57 4.57a.284.284 0 0 0 .267-.272C10.104 2.064 7.941-.105 5.432.004Z" }),
        React.createElement("path", { d: "M4.842 10.003a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" }),
        React.createElement("path", { d: "M12 8.003a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" }),
        React.createElement("path", { d: "M12 16.997a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" }),
        React.createElement("path", { d: "M17.16 8.003a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" }),
        React.createElement("path", { d: "M7.42 14.503a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" }),
        React.createElement("path", { d: "M14.58 12.503a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" })));
});
